<template>
  <section class="w-full h-full flex overflow-hidden">
    <div class="relative p-4 pb-0 box-border flex-1 overflow-hidden" v-loading="loading">
      <ArtificialService v-if="showArtificialService"/>
      <div style="height: calc(100% - 35px)" v-else-if="!showArtificialService && !loading">
        <TiltTabs
          :tabData="tabData"
          v-model="currentTab"
          @click-tab="changeTab"
          :tiltAngle="20"
          :activeHeight="62"
          :defaultHeight="46"
          activeBgColor="#4EB2FF"
          defaultBgColor="#F5F5F5"
          :leftBottomBallPosition="{left: '17px', top: '42px'}"
          :rightBottomBallPosition="{left: '-37px', top: '42px'}"
          activeLeftBgImage="linear-gradient(-90deg, #4EB2FF 0%, #1F75F3 100%)"
          activeRightBgImage="linear-gradient(-90deg, #1F75F3 0%, #4EB2FF 100%)">
          <div slot="leftTitle" class="text-medium-x font-semibold">自动估价</div>
          <div slot="leftSubTitle">无指定配额时样本预估价格</div>
          <div slot="rightTitle" class="text-medium-x font-semibold relative">
            人工估价
            <div class="meta-badge">推荐</div>
          </div>
          <div slot="rightSubTitle">专人服务，人工报价，满足个性化要求</div>
        </TiltTabs>
        <div class="empty pt-36 box-border" v-if="currentTab === 'artificial'">
          <div class="title">扫码联系客服，人工估价</div>
          <div class="text-medium text-theme-black-850">提供更多样本属性，支持按样本配额估价</div>
          <div class="text-medium pb-6 text-theme-black-850">现在联系，可获得更多优惠</div>
          <img src="/assets/img/code/Mrs.Chai.png" alt="" width="128" />
          <div><span class="text-theme-black-650 pt-2 pb-1">客服顾问：</span><span class="text-theme-black-850">柴女士</span></div>
          <div><span class="text-theme-black-650">联系电话：</span><span class="text-theme-black-850">18511821229</span></div>
        </div>
        <AutoService v-else/>
      </div>
      <!-- 网站协议文案提示 -->
      <DygcFooter class="my-2" />
    </div>
    <el-scrollbar wrapClass="overflow-x-hidden" class="w-290px h-full border-l border-solid border-theme-black-50 bg-white">
      <sample-contact-service :base-url="baseUrl" :scene="$route.query.scene"/>
      <sample-service-what />
      <sample-service-strengths :border="false" />
    </el-scrollbar>
  </section>
</template>

<script>
import GlobalConfig from '@/global/config'
import TiltTabs from "@/components/base/TiltTabs"
import ArtificialService from "./sample-components/ArtificialService"
import AutoService from "./sample-components/AutoService"
import SampleServiceWhat from './components/SampleServiceWhat'
import SampleContactService from './components/SampleContactService'
import SampleServiceStrengths from './components/SampleServiceStrengths'
import DygcFooter from 'components/dygc-footer-bottom/index'
import { querySampleServiceByUser } from "@/api/wenjuan/sampleService"

export default {
  name: 'SampleService',
  components: {
    SampleServiceWhat,
    SampleContactService,
    SampleServiceStrengths,
    DygcFooter,
    TiltTabs,
    ArtificialService,
    AutoService
  },
  data() {
    return {
      loading: true,
      currentTab: 'auto',
      tabData: [{
        key: 'auto',
        title: '自动估价',
        subTitle: '无指定配额时样本预估价格'
      }, {
        key: 'artificial',
        title: '人工估价',
        subTitle: '专人服务，人工报价，满足个性化要求'
      }],
      showArtificialService: false,
      timer: null
    }
  },
  watch: {
    currentTab(val) {
      if(val === 'artificial') {
        this.timer = setInterval(() => {
          this.getSampleServiceData()
        }, 3000)
      }
    },
    showArtificialService(val) {
      if(val) clearInterval(this.timer)
    }
  },
  methods: {
    changeTab(val) {
      this.currentTab = val
      if(val === 'auto') clearInterval(this.timer)
    },
    getSampleServiceData() {
      querySampleServiceByUser(GlobalConfig.getSurveyId()).then(res => {
        if(res.data.code !== 0) return
        this.showArtificialService = res.data.data.length > 0
      }).catch((err) => {console.log(err)})
      .finally(() => {
        this.loading = false
      })
    }
  },
  created() {
    this.getSampleServiceData()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>
<style scoped lang="scss">
.empty {
  height: calc(100% - 60px);
  @apply text-center leading-22 bg-white;
  .title {
    @apply font-semibold text-large pb-2 text-theme-black-850;
    font-family: PingFangSC-Medium;
  }
}

::v-deep .el-tag,.el-tag--mini {
  font-size: 10px;
  padding: 0 3px;
  margin-top: -2px;
}
.meta-badge {
  @apply absolute px-1 py-0.5 bg-danger text-white font-semibold;
  top: 4px;
  right: 0px;
  height: 12px;
  width: max-content;
  line-height: 12px;
  font-size: 8px;
  border-radius: 2px;
  font-family: PingFangSC-SNaNpxibold;
  transform: translateY(-50%) translateX(100%) scale(0.73);
}
</style>
